// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"926":"eb8a3920","3489":"6fa1a9ab"}[chunkId] + ".chunk.css";
};